'use client';
import { IMovie } from '@/interfaces/movie';
import React, { useEffect, useState } from 'react';
import MovieCardTab from '../movie-card-tab/movie-card-tab';

interface IProps {
  MovieTabOne: IMovie[];
  MovieTabTwo: IMovie[];
  titleOne?: string;
  titleTwo?: string;
}

function MovieRanked(props: IProps) {
  const { MovieTabOne, MovieTabTwo, titleOne, titleTwo } = props;
  const [selected, setSelected] = useState<number>(0);
  const [listMovie, setListMovie] = useState<IMovie[]>([]);
  const changeTab = (value: number) => {
    setSelected(value);
    if (value === 0) {
      setListMovie(MovieTabOne);
    } else {
      setListMovie(MovieTabTwo);
    }
  };
  useEffect(() => {
    setListMovie(MovieTabOne);
  }, []);
  return (
    <div>
      <div className="flex items-center gap-x-8  text-[14px] cursor-pointer font-medium">
        <div className="text-white">HOT</div>
        <div
          className={`text-gray-400 ${selected === 0 ? 'text-yellowMain' : ''}`}
          onClick={() => {
            changeTab(0);
          }}
        >
          {titleOne}
        </div>
        <div
          className={`text-gray-400 ${selected === 1 ? 'text-yellowMain' : ''}`}
          onClick={() => {
            changeTab(1);
          }}
        >
          {titleTwo}
        </div>
      </div>
      <div className="my-2 w-full h-[1px] bg-slate-500"></div>
      {listMovie.map((val: IMovie) => {
        return <MovieCardTab key={val.slug} movie={val} />;
      })}
    </div>
  );
}

export default MovieRanked;
